import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'app/shared/services/User/user.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material';
import { ViewScheduleComponent } from 'shared/reusable/view-schedule/view-schedule.component';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { environment } from 'environments/environment';
import { AppComponent } from 'app/app.component';
declare const countdown: any;


@Component({
  selector: 'app-get-ready',
  templateUrl: './get-ready.component.html',
  styleUrls: ['./get-ready.component.scss']
})
export class GetReadyComponent implements OnInit, OnDestroy {
  loading: boolean;
  groupId: string;
  currentGroup: any;
  isGroupLeader: boolean;
  refreshInterval: any;
  isAllMembersConnected: boolean;
  isDisableSelectButtion: boolean;
  draftOpenTime: string;
  leftPart: string;
  date: any = new Date();
  time: any = '';
  times: any = [];
  rawDraftTimes: any;
  count: any = 0;
  settings = {
    timePicker: false,
    format: 'MM-dd-yyyy',
    defaultOpen: false,
    closeOnSelect: true,
  };
  countDownInterval: any = null; 
  countDownStr: string;
  imageURL: string = environment.URL_TEAM_IMAGES;

  constructor(
    private data: DataSharingService,
    private gs: GroupService,
    private router: Router,
    private route: ActivatedRoute,
    private us: UserService,
    private dialog: MatDialog,
    private alertService: AlertPopupService,
    private app: AppComponent,
  ) { this.route.queryParams.subscribe(params => { this.groupId = params.groupId; }); }

  ngOnInit() {
    this.loading = true;
    this.data.changeTitle('GET READY');
    this.gs.refreshGroup(this.groupId).subscribe(res => {
      this.refreshGroup(res).then(data => {
        setTimeout(() => { this.loading = false; }, 1000);
      });
    });
    this.startInterval();
  }

  startInterval() {
    this.refreshInterval = setInterval(() => {
      this.gs.refreshGroup(this.groupId).subscribe(res => {
        console.log('Refreshing group........');
        this.refreshGroup(res);
      });
    }, 5000);
  }

  refreshGroup(res) {
    const promise = new Promise((resolve, reject) => {
      this.currentGroup = res;
      this.isGroupLeader = this.checkGroupLeader(this.currentGroup.leader_uid);
      this.isAllMembersConnected = this.checkAllMembersConnected(this.currentGroup.group_members);
      if ((this.currentGroup.group_status === 'PENDING_SCHEDULE' || this.currentGroup.group_status === 'EXPIRED') && this.isGroupLeader) {
        this.gs.getDraftSchedule(this.groupId).subscribe(response => {
          this.rawDraftTimes = response.days;
          if (this.count === 0) {
            this.selectDate('today');
            this.count++;
          }
        });
      }

      if (this.currentGroup.group_status === 'PENDING_SCHEDULE' || this.currentGroup.group_status === 'EXPIRED') {
        this.leftPart = 'Waiting for group leader to schedule Game Draft';
      }

      if (this.currentGroup.group_status === 'SCHEDULED') {
        this.draftOpenTime = moment.unix(this.currentGroup.sched_tstamp).format('LLLL');
        this.leftPart = 'Game Draft Scheduled';
      }
      if (this.currentGroup.group_status === 'OPEN') {
        this.leftPart = 'Draft Room Open';
      }

      if (this.currentGroup.group_status === 'DRAFT') {
        this.startDraft();
      }

      // SCHEDULED
      if (this.currentGroup.sched_tstamp != null) {
        if (this.currentGroup.sched_tstamp === '0' || this.currentGroup.sched_tstamp === '11') {
        } else {
          this.getReadableDraftTime(this.currentGroup.sched_tstamp);
          if (this.countDownInterval == null) {
            const end = moment.unix((Number(this.currentGroup.sched_tstamp)));
            if (countdown(end).seconds) {
              if(this.countDownInterval == null){
                this.startCountdown(res.sched_tstamp);
              }
            }
          }
          this.didDraftMiss();
        }
      } else {
        if (this.isAllMembersConnected) {
          this.isDisableSelectButtion = false;
        }
      }
      resolve();
    });
    return promise;
  }

  checkGroupLeader(leader_uid) {
    if (leader_uid === this.us.user.uid) {
      return true;
    } else {
      return false;
    }
  }

  checkAllMembersConnected(group_members) {
    for (let i = 0; i < group_members.length; i++) {
      if (group_members[i].did_onboard_ticketmaster === false) {
        this.isDisableSelectButtion = true;
        return false;
      }
    }
    return true;
  }

  startDraft() {
    this.router.navigate(['/draft'], { queryParams: { group_id: this.currentGroup.group_id } });
    clearInterval(this.refreshInterval);
  }

  getReadableDraftTime(t) {
    return moment.unix(t).format('MMM. D, YYYY [at] h:mm A z');
  }

  startCountdown(time) {
    if (this.countDownInterval == null) {
      this.countDownInterval = setInterval(() => {
        this.countDownStr = countdown(time * 1000).toString();
        console.log(this.countDownStr)
        if(this.countDownStr==''){
          clearInterval(this.countDownInterval)
        }
      }, 1000);
    }
  }

  didDraftMiss() {
    const tstamp = this.currentGroup.sched_tstamp;
    const startTime = moment(Number(tstamp) * 1000);
    const isSameHour = startTime.isSame(moment(), 'hour');
    if (!isSameHour) {
      const a = moment().diff(startTime, 'hour');
      if (a > 0) {
        clearInterval(this.countDownInterval);
      }
    } else {
      this.isDisableSelectButtion = true;
      if (this.checkAllMembersConnected(this.currentGroup.group_members)) {
        this.isAllMembersConnected = true;
      } else {
        this.isAllMembersConnected = false;
      }
    }
  }

  scheduleDraft() {
    this.gs.getDraftSchedule(this.groupId).subscribe(res => {

    });
  }


  viewSchedule() {
    const dialogRef = this.dialog.open(ViewScheduleComponent, {
      data: {
        eventName: this.currentGroup.season_ticket.tm_event_name,
        teamImage: this.currentGroup.season_ticket.team_thumb_img,
        teamName: this.currentGroup.season_ticket.team,
        teamDescription: this.currentGroup.season_ticket.description
      },
      width: '70%',
    });
  }

  mySeasonShare() {
    this.router.navigateByUrl('/groups')
  }
  liveChat() {
    window.open('https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=seasonshare.zendesk.com&settings=JTdCJTIyd2ViV2lkZ2V0JTIyJTNBJTdCJTIyY2hhdCUyMiUzQSU3QiUyMnRpdGxlJTIyJTNBbnVsbCUyQyUyMm1lbnVPcHRpb25zJTIyJTNBJTdCJTIyZW1haWxUcmFuc2NyaXB0JTIyJTNBdHJ1ZSU3RCUyQyUyMmRlcGFydG1lbnRzJTIyJTNBJTdCJTdEJTJDJTIycHJlY2hhdEZvcm0lMjIlM0ElN0IlMjJkZXBhcnRtZW50TGFiZWwlMjIlM0FudWxsJTJDJTIyZ3JlZXRpbmclMjIlM0FudWxsJTdEJTJDJTIyb2ZmbGluZUZvcm0lMjIlM0ElN0IlMjJncmVldGluZyUyMiUzQW51bGwlN0QlMkMlMjJjb25jaWVyZ2UlMjIlM0ElN0IlMjJhdmF0YXJQYXRoJTIyJTNBbnVsbCUyQyUyMm5hbWUlMjIlM0FudWxsJTJDJTIydGl0bGUlMjIlM0FudWxsJTdEJTdEJTJDJTIyY29sb3IlMjIlM0ElN0IlMjJhcnRpY2xlTGlua3MlMjIlM0ElMjIlMjIlMkMlMjJidXR0b24lMjIlM0ElMjIlMjIlMkMlMjJoZWFkZXIlMjIlM0ElMjIlMjIlMkMlMjJsYXVuY2hlciUyMiUzQSUyMiUyMiUyQyUyMmxhdW5jaGVyVGV4dCUyMiUzQSUyMiUyMiUyQyUyMnJlc3VsdExpc3RzJTIyJTNBJTIyJTIyJTJDJTIydGhlbWUlMjIlM0FudWxsJTdEJTdEJTdE&mid=&locale=en-US&title=Web%20Widget%20Live%20Chat', '_blank');
  }

  faq() {
    window.open('https://seasonshare.com/ticket-faq', '_blank');
  }

  messageGroup() {
  }

  saveDraftTime(startTime) {
    this.app.toggleLoadingMsg('Loading');
    if (startTime === 'now') {
      this.gs.saveDraftTime(this.groupId, Math.floor(Date.now() / 1000) + 10).subscribe(res => {
        this.gs.refreshGroup(this.groupId).subscribe(response => {
          this.refreshGroup(response);
          this.app.dismissLoading();
        });
      });
    } else {
      this.gs.saveDraftTime(this.groupId, this.time).subscribe(res => {
        this.gs.refreshGroup(this.groupId).subscribe(response => {
          this.refreshGroup(response);
          this.app.dismissLoading();
        });
      });
    }
  }

  selectDate(date) {
    setTimeout(() => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      if (moment(this.date).unix() > moment(currentDate).unix()) {
        const formatedDate = _.cloneDeep(moment(this.date).format('dddd MMM DD'));
        let x;
        if (date === 'today') {
          x = 0;
        } else {
          x = this.rawDraftTimes.findIndex(p => p.day_readable === formatedDate);
        }
        for (let i = 0; i < this.rawDraftTimes[x].tstamp.length; i++) {
          const today = new Date();
          const formatted = moment.unix(this.rawDraftTimes[x].tstamp[i]).format('YYYY-MM-DD HH:mm');
          const endTime = moment(formatted).format('hh:mm A');
          if (formatedDate === 'Today' && moment(today).isBefore(formatted)) {
            this.times.push({ description: endTime, rawTime: this.rawDraftTimes[x].tstamp[i] });
          }
          if (formatedDate !== 'Today') {
            this.times.push({ description: endTime, rawTime: this.rawDraftTimes[x].tstamp[i] });
          }
        }
        if (this.times.length === 0) {
          setTimeout(() => {
            this.alertService.errorAlert('No draft times are available for this day. Please try another day.');
          }, 500);
        }
      } else {
        this.alertService.errorAlert('You selected an invalid date ' + this.date);
      }
    }, 100);
  }

  ngOnDestroy() {
    clearInterval(this.refreshInterval);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/get-ready/get-ready.component.ts